module.exports = __webpack_public_path__ + "components/tide-table/static/moon-full-moon-8bf95c61bc92e01b7e633bbaecb3e34c.svg";